// wistiaHandler.ts

type WistiaInstance = any; // Replace with actual Wistia API type if known

interface WistiaInstancesMap {
  [videoId: string]: WistiaInstance;
}

// Global registry of Wistia video instances
const wistiaInstances: WistiaInstancesMap = {};

// Ensure TypeScript knows about window._wq
declare global {
  interface Window {
    _wq?: any[];
  }
}

/**
 * Extracts the Wistia video ID from an embed URL.
 */
const extractWistiaJsonpUrl = (url: string): string | null => {
  try {
    const match = url.match(/(?:wistia\.com|wistia\.net)\/(?:medias|embed)\/([a-zA-Z0-9]+)/);
    return match ? match[1] : null;
  } catch {
    return null;
  }
};

/**
 * Dynamically loads the Wistia player script if it hasn't been loaded already.
 */
const loadWistiaScripts = () => {
  const existingScript = document.querySelector('script[src*="fast.wistia.com/assets/external/E-v1.js"]');
  if (existingScript) return;

  const script = document.createElement("script");
  script.src = "https://fast.wistia.com/assets/external/E-v1.js";
  script.async = true;
  document.body.appendChild(script);
};

/**
 * Handles initialization of a Wistia video player instance from a URL.
 */
export const handleWistiaInstance = (embedUrl: string): void => {
  const videoId = extractWistiaJsonpUrl(embedUrl);
  if (!videoId) return;

  if (!window._wq) window._wq = [];

  window._wq.push({
    id: videoId,
    onReady: (videoInstance: WistiaInstance) => {
      wistiaInstances[videoId] = videoInstance;
    },
  });
  

  loadWistiaScripts();
};

export const pauseWistiaVideos = () => {
  if (typeof window !== "undefined" && window._wq) {
    for (const key in wistiaInstances) {
      const instance = wistiaInstances[key];
      if (instance?.pause) {
        instance.pause();
      }
    }
  }
};

export const removeWistiaInstance = (videoId: string) => {
  if (wistiaInstances[videoId]) {
    // Optionally call `.destroy()` or cleanup if the API supports it
    delete wistiaInstances[videoId];
  }
};
